export var ERFElement;
(function (ERFElement) {
    ERFElement["Absorber"] = "absorber";
    ERFElement["FlowEnergy"] = "flowEnergy";
    ERFElement["FlowMaterial"] = "flowMaterial";
    ERFElement["Separator2ph"] = "separator2ph";
    ERFElement["Separator3ph"] = "separator3ph";
    ERFElement["HeatExchanger"] = "heatExchanger";
    ERFElement["Coker"] = "coker";
    ERFElement["CokerRBlock"] = "cokerRBlock";
    ERFElement["CatCracking"] = "catCracking";
    ERFElement["CatCrackingRRBlock"] = "catCrackingRRBlock";
    ERFElement["CatReforming"] = "catReforming";
    ERFElement["CatReformingRRBlock"] = "catReformingRRBlock";
    ERFElement["DieselFuelHydrotreating"] = "dieselFuelHydrotreating";
    ERFElement["DieselFuelHydrotreatingRBlock"] = "dieselFuelHydrotreatingRBlock";
    ERFElement["DistillationColumnRC"] = "distillationColumnRC";
    ERFElement["Compressor"] = "compressor";
    ERFElement["Fractionator"] = "fractionator";
    ERFElement["Heater"] = "heater";
    ERFElement["Cooler"] = "cooler";
    ERFElement["Valve"] = "valve";
    ERFElement["Mixer"] = "mixer";
    ERFElement["Detander"] = "detander";
    ERFElement["ComponentSplitter"] = "componentSplitter";
    ERFElement["Splitter"] = "splitter";
    ERFElement["Pump"] = "pump";
    ERFElement["Pipeline"] = "pipeline";
    ERFElement["HeatExchangerSynthetic"] = "heatExchangerSynthetic";
    ERFElement["MultiStepCoherent"] = "multiStepCoherent";
    ERFElement["MultiStepExternal"] = "multiStepExternal";
    ERFElement["Balancer"] = "balancer";
    ERFElement["EngineTestSynthetic"] = "engineTestSynthetic";
    ERFElement["DotEnergy"] = "dotEnergy";
    ERFElement["DotMaterial"] = "dotMaterial";
    ERFElement["GroupDashed"] = "groupDashed";
    ERFElement["Element"] = "element";
    ERFElement["Recycle"] = "recycle";
    ERFElement["Function"] = "function";
    ERFElement["Optimization"] = "optimization"; // Оптимизатор (логический элемент)
})(ERFElement || (ERFElement = {}));
export var ERFEdge;
(function (ERFEdge) {
    ERFEdge["Default"] = "default";
    ERFEdge["Material"] = "material";
    ERFEdge["Energy"] = "energy";
    ERFEdge["Logical"] = "logical";
    ERFEdge["Recycle"] = "recycle";
})(ERFEdge || (ERFEdge = {}));
//# sourceMappingURL=rfElement.enum.js.map